<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ikl6M5/tc-custom/9781429915717.jpg?1721099590996" alt="This image is the cover for the book Far Reaches, Josh Thurlow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Far Reaches, Josh Thurlow
      </h1>
      <p class="bookDescription body article font2">
        <b>Amid the chaos of WWII, a Coast Guard Captain is conscripted into battling a ruthless outlaw in this thriller from the <i>New York Times</i>–bestselling author.</b><br/><br/>As World War II rages in the Pacific, Coast Guard Captain Josh Thurlow is sent in to assess the status of the campaign. He’s there at the disastrous invasion of Tarawa, as the US Navy begins throwing marines at island after island. One of the few survivors, Josh’s life is saved by a young Irish nun. But Sister Mary Kathleen is not what she seems.<br/><br/>Sister Mary shanghaies Josh—along with Bosun Ready O’Neal and three marines—in a desperate scheme to save a group of tropical islands from a brutal Japanese warlord. Now Josh and the others must decide whose war they’re willing to fight—and whether they can trust this tough and mysterious woman of God . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Homer Hickam
      </h2>
      
      <p class="authorDescription body article"><P>HOMER HICKAM is the author of the #1 <I>New York </I>Times bestseller <I>Rocket Boys</I>, which was made into the acclaimed movie <I>October </I>Sky.  A respected amateur historian, he is also the author of the military history best-seller <I>Torpedo Junction</I>, along with the popular historical novels <I>The Keeper's Son </I>and<I> The Ambassador's Son</I>.  With a totla of nine books to his credit, including the award-winning memoir <I>Sky of Stone</I>, and the techno-thriller best-seller <I>Back to the Moon</I>, Hickam's talents clearly span many writing genres. He is a Vietnam combat veteran, a scuba instructor who has led underwater exploration teams across the world, a retired rocket scientist, and, recently, has become an avid field paleontologist.  More than anything else, he loves to write.  He is married to Linda Terry Hickam, an artist, who is also his assistant.  They share their time with their cats between homes in Alabama and the U. S. Virgin Islands.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?460830d2